import { SVGProps } from 'react';

export const TrendUp = ({ width = 16, height = 16, fill = '#689d11' }: SVGProps<SVGElement>): JSX.Element => (
  <svg width={width} height={height} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 6.75732L12.2426 11H3.75736L8 6.75732Z" fill={fill} />
  </svg>
);
